import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AppUtilityHelper {
  public calcolaParamentriUrl(paramsString: string): Object {
    let params: Object = {};

    for (let singleParam of paramsString.split("&")) {
      console.log(
        "[AppUtilityHelper][calcolaParamentriUrl] singleParams: ",
        singleParam
      );
      params[singleParam.split("=")[0]] = decodeURI(singleParam.split("=")[1]);
    }
    console.log("[AppUtilityHelper][calcolaParamentriUrl] params: ", params);
    return params;
  }

  // tslint:disable-next-line:member-ordering
  public static azzeraMinutiSecondi(data: string): string {
    const dataTemp: Date = new Date(data);
    dataTemp.setHours(0);
    dataTemp.setMinutes(0);
    dataTemp.setSeconds(0);
    return dataTemp.toISOString();
  }
}
